import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './projects.css'; // Ensure styles are applied from projects.css

const forestClubImages = [
  { id: 1, thumbnail: '../images/forestclub/forestclub1.jpg', fullImage: '../images/forestclub/forestclub1.jpg' },
  { id: 2, thumbnail: '../images/forestclub/forestclub2.jpg', fullImage: '../images/forestclub/forestclub2.jpg' },
  { id: 3, thumbnail: '../images/forestclub/forestclub3.jpg', fullImage: '../images/forestclub/forestclub3.jpg' },
  { id: 4, thumbnail: '../images/forestclub/forestclub4.jpg', fullImage: '../images/forestclub/forestclub4.jpg' },
  { id: 5, thumbnail: '../images/forestclub/forestclub5.jpg', fullImage: '../images/forestclub/forestclub5.jpg' },
  { id: 6, thumbnail: '../images/forestclub/forestclub6.jpg', fullImage: '../images/forestclub/forestclub6.jpg' },
  { id: 7, thumbnail: '../images/forestclub/forestclub7.jpg', fullImage: '../images/forestclub/forestclub7.jpg' },
  { id: 8, thumbnail: '../images/forestclub/forestclub8.jpg', fullImage: '../images/forestclub/forestclub8.jpg' },
  { id: 9, thumbnail: '../images/forestclub/forestclub9.jpg', fullImage: '../images/forestclub/forestclub9.jpg' },
  { id: 10, thumbnail: '../images/forestclub/forestclub10.jpg', fullImage: '../images/forestclub/forestclub10.jpg' },
  // Add more images as needed
];

function ForestClub() {
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/projects');
  };

  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  const handleClose = () => {
    setSelectedImageIndex(null);
  };

  const handlePrev = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : forestClubImages.length - 1));
  };

  const handleNext = () => {
    setSelectedImageIndex((prevIndex) => (prevIndex < forestClubImages.length - 1 ? prevIndex + 1 : 0));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (selectedImageIndex !== null) {
        if (event.key === 'ArrowLeft') {
          handlePrev();
        } else if (event.key === 'ArrowRight') {
          handleNext();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [selectedImageIndex]);

  return (
    <div className="project-detail">
      <button className="back-button" onClick={handleBack}>НАЗАД ВО ВСЕ ПРОЕКТЫ</button>
      <h1>Forest Club</h1>
      <div className="project-detail-grid">
        {forestClubImages.map((image, index) => (
          <div key={image.id} className="project-detail-item">
            <img
              src={image.thumbnail}
              alt={`Forest Club Image ${index + 1}`}
              onClick={() => handleImageClick(index)}
            />
          </div>
        ))}
      </div>

      <button className="back-button back-button-end" onClick={handleBack}>НАЗАД ВО ВСЕ ПРОЕКТЫ</button>

      {selectedImageIndex !== null && (
        <div className="project-popup" onClick={handleClose}>
          <div className="project-popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={handleClose}>X</button>
            <button className="nav-button left" onClick={handlePrev}>&lt;</button>
            <img src={forestClubImages[selectedImageIndex].fullImage} alt={`Forest Club Image ${selectedImageIndex + 1}`} />
            <button className="nav-button right" onClick={handleNext}>&gt;</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ForestClub;
